import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        redirect: '/HomePage',
    },
    {
        path: '/Home',
        redirect: '/HomePage',
    },
    {
        path: '/HomePage',
        name: 'HomePage',
        component: () => import('@/views/homePage/HomePage.vue'),
    },
    {
        path: '/s/:articleId',
        redirect: { name: 'articlePage' },
    },
    {
        path: '/articlePage/:articleId',
        name: 'articlePage',
        component: () => import('@/views/articlePage/Article.vue'),
    },
    {
        path: '/ranking/:page',
        name: 'ranking',
        component: () => import('@/views/itemList/RankingArticleList.vue'),
    },
    {
        path: '/search/:search/:page',
        name: 'search',
        component: () => import('@/views/itemList/SearchArticleList.vue'),
    },
    {
        path: '/tag/:tag/:page',
        name: 'tag',
        component: () => import('@/views/itemList/TagArticleList.vue'),
    },
    {
        path: '/categories/:categories/:page',
        name: 'categories',
        component: () => import('@/views/itemList/CategoriesArticleList.vue'),
    },
    {
        path: '/error/:errorCode',
        name: 'error',
        component: () => import('@/views/Error.vue'),
    },
    {
        path: '/*',
        component: () => import('@/views/Error.vue'),
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
    routes,
});

export default router;
